import React, { useState } from 'react';

import styled from 'styled-components';


import closeIcon from '../../../assets/small-close-button.png';
import { COLORS } from '../../../utils/theme/colors';
import SearchIcon from '../icons/SearchIcon';

export const SearchInput = (props) => {
  const { inputArray, mode, removeTagFunction, value, closeBtn } = props;

  const [activeTooltip, setActiveTooltip] = useState(false);

  const maxInputArrayLength = 4;

  switch (mode) {
    case 'default':
      return <Input type='search' autoComplete={'off'} {...props} />;

    case 'tag':
      return (
        <InputTagWrapper>
          <InputTagList overflowed={inputArray.length > maxInputArrayLength}>
            {inputArray.length <= maxInputArrayLength + 1 ? (
              inputArray.map((input, index) => {
                if (input === '') {
                  return null;
                }

                let letterCount = input.replace(/\s+/g, '').length;
                return (
                  <InputTagElement
                    onClick={() => removeTagFunction(input)}
                    onMouseEnter={() => {
                      if (activeTooltip === false) setActiveTooltip(index);
                    }}
                    onMouseLeave={() => {
                      if (activeTooltip !== false) setActiveTooltip(false);
                    }}
                  >
                    {letterCount > 7 ? `${input.substring(0, 7)}...` : input}
                    <span className='remove-tag-button' alt='remove tag'>
                      x
                    </span>
                    <InputTagElementTooltip className={`${activeTooltip === index ? 'active' : ''}`}>{input}</InputTagElementTooltip>
                  </InputTagElement>
                );
              })
            ) : (
              <InputTagOverflowedListWrapper>
                <div>
                  {inputArray.map((input, index) => {
                    if (input === '') {
                      return null;
                    }

                    let letterCount = input.replace(/\s+/g, '').length;

                    return index <= maxInputArrayLength ? (
                      <InputTagElement
                        onClick={() => removeTagFunction(input)}
                        onMouseEnter={() => {
                          if (activeTooltip === false) setActiveTooltip(index);
                        }}
                        onMouseLeave={() => {
                          if (activeTooltip !== false) setActiveTooltip(false);
                        }}
                      >
                        {letterCount > 7 ? `${input.substring(0, 7)}...` : input}
                        <span className='remove-tag-button' alt='remove tag'>
                          x
                        </span>
                        <InputTagElementTooltip className={`${activeTooltip === index ? 'active' : ''}`}>{input}</InputTagElementTooltip>
                      </InputTagElement>
                    ) : null;
                  })}
                  <InputTagOverflowedListSeeMore>+</InputTagOverflowedListSeeMore>
                </div>
                <InputTagOverflowedListElementWrapper>
                  {inputArray.map((input, index) => {
                    if (input === '' || index < maxInputArrayLength + 1) {
                      return null;
                    }

                    let letterCount = input.replace(/\s+/g, '').length;

                    return (
                      <InputTagOverflowedElement
                        className='overflowed'
                        onClick={() => removeTagFunction(input)}
                        onMouseEnter={() => {
                          if (activeTooltip === false) setActiveTooltip(index);
                        }}
                        onMouseLeave={() => {
                          if (activeTooltip !== false) setActiveTooltip(false);
                        }}
                      >
                        {letterCount > 7 ? `${input.substring(0, 7)}...` : input}
                        <span className='remove-tag-button' alt='remove tag'>
                          x
                        </span>
                        <InputTagElementTooltip className={`${activeTooltip === index ? 'active' : ''}`}>{input}</InputTagElementTooltip>
                      </InputTagOverflowedElement>
                    );
                  })}
                </InputTagOverflowedListElementWrapper>
              </InputTagOverflowedListWrapper>
            )}
          </InputTagList>
          <InputTag type='search' autoComplete={'off'} {...props} />
          {value && <img onClick={closeBtn} className='close_list_button' src={closeIcon} alt='close list button' />}
          <SearchIcon fill={'rgba(0, 0, 0, 0.5)'} />
        </InputTagWrapper>
      );

    default:
      return null;
  }
};

const InputTag = styled.input`
  height: 40px;
  background-color: #fff;
  color: rgba(0, 0, 0, 0.5);
  outline: none;
  min-width: 31em;
  padding: 0 70px 0 30px;
`;

const InputTagWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 21em;
  background-color: #fff;
  color: rgba(0, 0, 0, 0.5);
  outline: none;
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  overflow: hidden;

  &::placeholder {
    color: rgba(0, 0, 0, 0.5);
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 0 12% 0 5%;
  height: 40px;
  background-color: #fff;
  color: rgba(0, 0, 0, 0.5);
  border-radius: 3px;
  margin-bottom: 3px;
  outline: none;

  &::placeholder {
    color: rgba(0, 0, 0, 0.5);
  }
`;

const InputTagList = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 0;
  margin-bottom: 0;
  flex-wrap: wrap;
  border-radius: 3px;
`;

const InputTagElement = styled.li`
  position: relative;
  list-style: none;
  background-color: ${COLORS.lightBlueBackground};
  padding: 0.3em 0.5em;
  font-size: 11px;
  max-height: 2.2em;
  display: inline;
  padding-right: 0.7em;
  cursor: pointer;
  border-radius: 3px;

  &:not(:nth-child(4)) {
    margin-left: 20px;
    margin-right: 0.8em;
  }

  .remove-tag-button {
    position: absolute;
    top: -3px;
    cursor: pointer;
    right: 3px;
    font-size: 10px;
    max-width: fit-content;
  }
`;

const InputTagOverflowedElement = styled.li`
  position: relative;
  list-style: none;
  background-color: ${COLORS.lightBlueBackground};
  padding: 0.3em 0.5em;
  font-size: 11px;
  max-height: 2.2em;
  display: inline;
  padding-right: 0.7em;
  cursor: pointer;
  border-radius: 3px;
  margin-top: 8px;
  margin-left: 8px;
  margin-right: 0;

  .remove-tag-button {
    position: absolute;
    top: -3px;
    cursor: pointer;
    right: 3px;
    font-size: 10px;
    max-width: fit-content;
  }


`;

const InputTagElementTooltip = styled.div`
  display: none;

  &.active {
    transition: all 2000ms ease-in-out;
    width: max-content;
    border-radius: 3px;
    font-size: 10px;
    display: block;
    position: absolute;
    z-index: 9;
    color: #000;
    bottom: -2.5em;
    left: 0;
    background-color: ${COLORS.hover};
    color: #000;
    padding: 0.3em 0.5em;
  }
`;

const InputTagOverflowedListWrapper = styled.div`
  position: relative;
`;

const InputTagOverflowedListElementWrapper = styled.ul`
  position: absolute;
  right: 0;
  top: 2em;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  overflow: visible;
  z-index: 9;
`;

const InputTagOverflowedListSeeMore = styled.div`
  position: relative;
  list-style: none;
  padding: 0.3em 0.5em;
  font-size: 11px;
  max-height: 2.2em;
  display: inline;
  cursor: pointer;
  margin-left: 8px;
  background-color: ${COLORS.lightBlueBackground};
  border-radius: 3px;
`;
